export const FETCH_WORKING_PLANTS_REQUEST = 'FETCH_WORKING_PLANTS_REQUEST';
export const FETCH_WORKING_PLANTS_SUCCESS = 'FETCH_WORKING_PLANTS_SUCCESS';
export const FETCH_WORKING_PLANTS_FAILURE = 'FETCH_WORKING_PLANTS_FAILURE';

export const FETCH_WORKING_HOURS_REQUEST = 'FETCH_WORKING_HOURS_REQUEST';
export const FETCH_WORKING_HOURS_SUCCESS = 'FETCH_WORKING_HOURS_SUCCESS';
export const FETCH_WORKING_HOURS_FAILURE = 'FETCH_WORKING_HOURS_FAILURE';

export const UPDATE_WORKING_HOURS_REQUEST = 'UPDATE_WORKING_HOURS_REQUEST';
export const UPDATE_WORKING_HOURS_SUCCESS = 'UPDATE_WORKING_HOURS_SUCCESS';
export const UPDATE_WORKING_HOURS_FAILURE = 'UPDATE_WORKING_HOURS_FAILURE';

export const RESTORE_WORKING_HOURS_REQUEST = 'RESTORE_WORKING_HOURS_REQUEST';
export const RESTORE_WORKING_HOURS_SUCCESS = 'RESTORE_WORKING_HOURS_SUCCESS';
export const RESTORE_WORKING_HOURS_FAILURE = 'RESTORE_WORKING_HOURS_FAILURE';

export const SET_DEFAULT_WORKING_HOURS = 'SET_DEFAULT_WORKING_HOURS';
